import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { MaskedLines, Reveal } from "../components/motion";
import { faqs } from "../data/content";
import { usePageTitle } from "../lib/title";

export default function FaqPage() {
  usePageTitle("Frequently Asked Questions");
  return (
    <div data-testid="faq-page">
      <section className="mx-auto max-w-4xl px-6 pb-16 pt-36 lg:px-10 lg:pt-44" data-testid="faq-hero">
        <h1 className="font-mono text-xs uppercase tracking-[0.35em] text-terra" data-testid="faq-kicker">
          Health Insurance &amp; Group Benefits FAQ
        </h1>
        <MaskedLines
          as="p"
          className="mt-8 font-serif text-5xl font-light leading-[0.95] tracking-tighter text-forest sm:text-6xl lg:text-7xl"
          lines={["Asked, and answered", "in plain language."]}
        />
      </section>

      <section className="mx-auto max-w-4xl px-6 pb-24 lg:px-10 lg:pb-32" data-testid="faq-list">
        <Reveal>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-border"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="py-7 text-left font-serif text-xl font-medium tracking-tight text-forest hover:text-terra hover:no-underline sm:text-2xl"
                  data-testid={`faq-question-${i}`}
                >
                  <span>
                    <span className="mr-5 font-mono text-xs tracking-[0.3em] text-terra">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {f.q}
                  </span>
                </AccordionTrigger>
                <AccordionContent
                  className="pb-7 pl-0 pr-4 text-base leading-relaxed text-ink/70 sm:pl-12"
                  data-testid={`faq-answer-${i}`}
                >
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-16 border border-border bg-sand/50 p-8 lg:p-10" data-testid="faq-cta">
            <h3 className="font-serif text-2xl font-medium tracking-tight text-forest sm:text-3xl">
              Don't see your question? <em className="text-terra">Ask me directly.</em>
            </h3>
            <Link
              to="/contact"
              data-testid="faq-contact-cta"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-forest px-8 py-3.5 text-sm font-medium text-cream transition-all duration-300 hover:-translate-y-1 hover:bg-moss"
            >
              Send a Message
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
